<template>
    <div class="recStandard-page" :style="{ 'max-height': noHead === 'true' ? '100%' : 'calc(100% - 0.98rem)' }"></div>
</template>

<script>
import { jump } from '@/mixins/pageJump/'
import loginType from '@/constant/loginType'
import { urls } from '@/constant/paths'

export default {
    name: 'RecStandard',

    beforeRouteEnter(to, from, next) {
        const urlConfig = {
            owfUrl: '/mobile/cn/sc/login',
            cxUrl: `${urls.MP_CHECK_TICKET}?type=${loginType.WX_ACCEPT}`
        }
        jump(urlConfig)
    }
}
</script>

<style lang="scss" scoped>
.recStandard-page {
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/recStandard/std.vue